<template src="./list.html"></template>

<script>

import ServiceService from 'Services/ServiceService';

export default {
  data() {
    return {
      serviceJP: {},
      serviceVN: {},
      i18n: 2,
    };
  },

  created() {
    this.list();
  },

  methods: {
    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const paramsJP = {
        type: 3,
        national: 1,
        i18n: this.i18n,
      };

      const paramsVN = {
        type: 3,
        national: 2,
        i18n: this.i18n,
      };

      ServiceService.listClient(paramsJP)
        .then((response) => {
          this.serviceJP = response.data;
        })
        .catch(() => {});
      ServiceService.listClient(paramsVN)
        .then((response) => {
          this.serviceVN = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
}
</style>
